export const QUESTIONS = [
  {
    q: "When you think about creating more money or freedom in your life, what usually happens first?",
    answers: [
      { key: "A", text: "I immediately start thinking about everything I'd need to figure out before I could begin." },
      { key: "B", text: "I think, \u201cOkay. I just need to work harder or do more.\u201d" },
      { key: "C", text: "I get excited... and then start thinking about everything I could lose or screw up." },
      { key: "D", text: "I think about money itself\u2014and how I never seem to feel like I have enough of it." },
      { key: "E", text: "I genuinely don't know what I'd do. I know I'm capable of more, but I don't know what my \u201cthing\u201d is." },
    ],
  },
  {
    q: "Which sentence sounds MOST like you?",
    answers: [
      { key: "A", text: "\u201cI need to figure this out before I start.\u201d" },
      { key: "B", text: "\u201cIf I want something done right, I should probably just do it myself.\u201d" },
      { key: "C", text: "\u201cI can't just blow up my life chasing some crazy idea.\u201d" },
      { key: "D", text: "\u201cI make money. Where the hell does it all go?\u201d" },
      { key: "E", text: "\u201cI know I'm good at a lot of things. I just don't know how any of them become MORE.\u201d" },
    ],
  },
  {
    q: "Someone offers you an incredible opportunity that's outside your comfort zone. What's your first INTERNAL reaction?",
    answers: [
      { key: "A", text: "I need more information." },
      { key: "B", text: "I can do it. I'll just have to work my ass off." },
      { key: "C", text: "Whoa. What if I fail?" },
      { key: "D", text: "Can I afford to do this?" },
      { key: "E", text: "Why would they choose me?" },
    ],
  },
  {
    q: "If I magically deposited an extra $5,000 into your account today, what feels MOST likely?",
    answers: [
      { key: "A", text: "I'd research the smartest possible thing to do with it before touching it." },
      { key: "B", text: "I'd probably use it to tackle something that's been hanging over my head." },
      { key: "C", text: "I'd want to save most of it because I'd be nervous about not having it later." },
      { key: "D", text: "Honestly? Somehow, eventually, it would probably disappear." },
      { key: "E", text: "I'd love to use some of it to create something\u2014but I'm not sure what." },
    ],
  },
  {
    q: "Finish this sentence: \u201cIf I knew I couldn't fail, I would\u2026\u201d",
    answers: [
      { key: "A", text: "Finally start one of the things I've been thinking about forever." },
      { key: "B", text: "Go much bigger than I'm currently going." },
      { key: "C", text: "Take a risk I've been afraid to take." },
      { key: "D", text: "Completely change the way I earn and use money." },
      { key: "E", text: "Figure out what I'm really meant to be doing\u2014and GO." },
    ],
  },
];

export const RESULTS = {
  A: {
    name: "The Overthinker",
    headline: "Your brain is brilliant. It may also be exhausting you.",
    body: [
      "You don't lack ideas.\nYou probably don't lack intelligence, ambition, or capability either.",
      "Your instinct is to understand things before you act. That's a strength. It makes you thoughtful, prepared, discerning, and less likely to make reckless decisions.",
      "But taken too far, preparation becomes procrastination. You keep trying to eliminate uncertainty before taking action.",
      "And here's the problem: the next chapter of your life probably can't be figured out entirely from where you're standing now.",
      "Some answers only appear AFTER you move.",
    ],
    question: "What have you been trying to figure out that you could simply TEST instead?",
    exercise: [
      "Write down one thing you've been thinking about doing for more than three months.",
      "Now ask: what's the smallest real-world action I could take on this in the next 48 hours?",
      "Not research.\nNot planning.\nAction.",
    ],
  },
  B: {
    name: "The Hard Worker",
    headline: "Your greatest strength may also be your biggest limitation.",
    body: [
      "You're capable.\nReliable.\nResourceful.",
      "When something needs to happen, you make shit happen. That has probably gotten you pretty far.",
      "But somewhere along the way, you may have learned: more success = more effort.",
      "So when you want more money, freedom, impact, or opportunity, your instinct is to add:",
      "More hours.\nMore responsibility.\nMore hustle.\nMore YOU.",
      "But what if your next level doesn't require more of you?",
      "What if it requires using the BEST of you differently?",
    ],
    question: "What are you exceptionally good at that creates disproportionate value?",
    exercise: [
      "Make two lists.",
      "LIST ONE: the three things you do exceptionally well that create the MOST value.",
      "LIST TWO: the three things currently consuming the MOST of your time.",
      "How much overlap is there?\nPay attention to that answer.",
    ],
  },
  C: {
    name: "The Playing-It-Safer",
    headline: "You're not afraid of success. You're very aware of what you could lose.",
    body: [
      "You're thoughtful.\nResponsible.\nYou understand consequences.",
      "Those are strengths.",
      "But sometimes being \u201crealistic\u201d becomes a very sophisticated way of staying exactly where we are.",
      "You may have ideas. You may even know what you want. But before you move toward possibility, your brain immediately calculates risk.",
      "What if I fail?\nWhat if I lose money?\nWhat if I embarrass myself?\nWhat if I disrupt something that's already working?",
      "Those aren't ridiculous questions. But there's another question worth asking:",
      "What's the risk of staying exactly where you are?",
    ],
    question: "If nothing changed over the next three years, how would you feel about the life you're living today?",
    exercise: [
      "Write down something you want but have been afraid to pursue.",
      "Create two columns:\nWHAT COULD GO WRONG?\nand\nWHAT COULD GO RIGHT?",
      "Give both sides equal airtime.\nYour brain probably hasn't been doing that.",
    ],
  },
  D: {
    name: "The Money Cycler",
    headline: "You may not have an income problem. You may have a pattern.",
    body: [
      "Maybe you make good money. Maybe your income has grown substantially. Maybe you've even had periods when you felt genuinely abundant.",
      "And yet...",
      "Somehow you keep finding yourself back in a strangely familiar financial place.",
      "Money comes.\nMoney goes.\nYou save.\nSomething happens.\nYou earn more.\nYour spending expands.",
      "Or maybe you simply avoid looking too closely at any of it.",
      "This isn't about shame. It's about observation.",
      "Because you can't interrupt a pattern you can't see.",
    ],
    question: "If I looked at the last five years of your financial life as a repeating story, what would the plot be?",
    exercise: [
      "Without judging yourself, finish this sentence:",
      "\u201cWhenever I have money, I tend to __________.\u201d",
      "Then:",
      "\u201cWhenever I DON'T have enough money, I tend to __________.\u201d",
      "Don't fix anything yet.\nJust notice.\nAwareness comes first.",
    ],
  },
  E: {
    name: "The Hidden Powerhouse",
    headline: "You may be sitting on far more value than you realize.",
    body: [
      "You're capable. You probably have a weird combination of experiences, skills, talents, relationships, and knowledge that nobody else possesses in exactly the same way.",
      "The problem?",
      "A lot of what you're exceptional at feels NORMAL to you. Because it's easy for you, you assume it's easy for everyone.",
      "It isn't.",
      "Your next opportunity may not require learning another skill.",
      "It may require finally recognizing the value of the ones you already have.",
    ],
    question: "What do people consistently come to YOU for help with?",
    exercise: [
      "Text three people who know you well and ask them:",
      "\u201cWhat is something you think I'm unusually good at?\u201d",
      "Don't explain why you're asking.\nDon't argue with their answers.\nDon't minimize them.",
      "Collect the data. You might be surprised by what other people can see that you can't.",
    ],
  },
};

export const AFTER_RESULT = {
  lead: "Here's where it gets interesting.",
  paragraphs: [
    "This pattern isn't who you are. It's simply one of the ways you've learned to operate. And once you can SEE a pattern, you can start making different choices.",
    "That's exactly the kind of work we do inside Creating Wealth Through Community. But we don't stop at awareness.",
    "Over the course of 13 guided transformational courses + one bonus course, I'll help you move through:",
  ],
  path: ["YOU", "MONEY", "POSSIBILITY", "CREATE"],
  bullets: [
    "Uncover what makes you uniquely powerful",
    "Identify the beliefs and patterns that keep getting in your way",
    "Understand your relationship with money",
    "Define what wealth actually means to YOU",
    "Discover the skills, talents, and experiences you may be undervaluing",
    "Explore what you could create from them",
    "Test those ideas in the real world",
    "And if you decide to turn one into income, take the first steps toward actually getting paid",
  ],
  closing: "All while surrounded by a community of people doing the same work alongside you.",
};
